export function AboutPage() {
  return (
    <div className="site-container page">
      <section className="page-intro">
        <p className="page-intro__label">About</p>
        <h1>The things that inform the work.</h1>
        <p>This is where the site will make room for the person behind the résumé: university life, books, classical guitar, faith, community, and the questions that keep mattering.</p>
      </section>
    </div>
  );
}
